import api from '../../api/api.js'
import request from '../../api/request.js'

const state = () => ({
  msgCount: 0,
  alarmCount: 0,
  total: 0
})

const mutations = {
  setCounts(state, payload) {
    state.msgCount = Number(payload.msgCount || 0)
    state.alarmCount = Number(payload.alarmCount || 0)
    state.total = Number(payload.total || (state.msgCount + state.alarmCount) || 0)
  }
}

const actions = {
  async loadCounts({ commit }) {
    try {
      const res = await new request(api.m().task_getNoDeal, {}).modepost()
      if (res && res.status === 200) {
        const data = res.data && res.data.data
        if (data && (typeof data === 'object')) {
          commit('setCounts', {
            msgCount: data.msgCount,
            alarmCount: data.alarmCount,
            total: data.total
          })
        } else {
          // fallback if backend returns flat shape
          commit('setCounts', {
            msgCount: res.data.msgCount,
            alarmCount: res.data.alarmCount,
            total: res.data.total
          })
        }
      }
    } catch (e) {
      // ignore errors; keep previous counts
    }
  }
}

const getters = {
  msgCount: (state) => state.msgCount,
  alarmCount: (state) => state.alarmCount,
  totalCount: (state) => state.total
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}


